import { render, staticRenderFns } from "./TrustDocVerifyWait.vue?vue&type=template&id=0d82bd21&scoped=true"
import script from "./TrustDocVerifyWait.vue?vue&type=script&lang=js"
export * from "./TrustDocVerifyWait.vue?vue&type=script&lang=js"
import style0 from "./TrustDocVerifyWait.vue?vue&type=style&index=0&id=0d82bd21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d82bd21",
  null
  
)

export default component.exports